<template>
    <div class="home">
        <h2>Welcome to WebApiStudio.com</h2>
        <p>
            This is my personal playground for working with browser Web APIs and other JavaScript projects.
            You can find here specific "debuggers" and "sandboxes" to play or experiment with browser Web APIs
            or other technologies that I use in my personal projects.
        </p>

        <p>
            MIDI itself for example is not a Web or
            JavaScript specific technology, but as I the MIDI Web API in some projects I have created some tools
            to help me work with the technology.
        </p>

        <p>
            If you have any questions, remarks, feedback or just want to get in touch, you can fine me on
            <a href="https://twitter.com/SegersIan" target="_blank">Twitter</a>, mail me at <a href="mailto:ask@segersian.com">ask@segersian.com</a> or just check my
            <a href="http://segersian.com">website</a>. I try to post about my projects and experiences on <a href="https://medium.com/@segersian" target="_blank">Medium</a>.
        </p>

        <p>
            <em>As I might be using experimental APIs on this site, please use the latest Chrome for compatibility.</em>
        </p>

        <p>Enjoy!</p>

        <p>Ian</p>

        <h2>Source Code</h2>
        This site is written in VueJs and you can check the entire source code on <a target="_blank" href="https://github.com/SegersIan/midipedia">GitHub</a>.
    </div>
</template>

<script>

    export default {
        name: 'home',
        created() {

        }
    }
</script>

<style>


</style>
